import { render, staticRenderFns } from "./FileRenameDialog.vue?vue&type=template&id=5397b9e5&scoped=true&"
import script from "./FileRenameDialog.vue?vue&type=script&lang=js&"
export * from "./FileRenameDialog.vue?vue&type=script&lang=js&"
import style0 from "./FileRenameDialog.vue?vue&type=style&index=0&id=5397b9e5&prod&scoped=true&lang=css&"
import style1 from "./FileRenameDialog.vue?vue&type=style&index=1&id=5397b9e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397b9e5",
  null
  
)

export default component.exports